import { PartActionType } from '../@types/partAction.type';

export const SAMPLE_PART_ACTION_IN_OUT_HELPER_TEXT = {
  partTypeHelperText: '',
  partSerialHelperText: '',
  locationHelperText: '',
  noteHelperText: ''
};

export const SAMPLE_PART_ACTION_CARD_HELPER_TEXT = {
  in: SAMPLE_PART_ACTION_IN_OUT_HELPER_TEXT,
  out: SAMPLE_PART_ACTION_IN_OUT_HELPER_TEXT,
  id: 0,
  partActionType: ''
};

export const PART_TYPE_CANNOT_EMPTY = 'Part Type field cannot be empty';
export const PART_SERIAL_CANNOT_EMPTY = 'Part Serial field cannot be empty';
export const LOCATION_CANNOT_EMPTY = 'Location field cannot be empty';
export const NOTE_CANNOT_EMPTY = 'Note field cannot be empty';
export const QUANTITY_CANNOT_EMPTY = 'Quantity cannot be empty';

export const VALID_PART_ACTION_TYPE_CODES = ['install', 'remove', 'replace', 'doa', 'test', 'clean', 'repair', 'adjust'];

export const REPAIR_ACTIONS = [
  { label: '3rd Party Repaired', value: '3rd-party-repaired' },
  { label: 'Adjusted', value: 'adjusted' },
  { label: 'Assembled new cable', value: 'assembled-new-cable' },
  { label: 'Cleaned optical sensors', value: 'cleaned-optical-sensors' },
  { label: 'Connected', value: 'connected' },
  { label: 'Fitted refurbished part(s)', value: 'fitted-refurbished-parts' },
  { label: 'No Fault Found', value: 'no-fault-found' },
  { label: 'Re-calibrated', value: 're-calibrated' },
  { label: 'Reconfigure/Manually Enter', value: 'reconfigure-manually-enter' },
  { label: 'Reloaded/Re-Image', value: 'reloaded-re-image' },
  { label: 'Repaired casing', value: 'repaired-casing' },
  { label: 'Repaired circuit board', value: 'repaired-circuit-board' },
  { label: 'Repaired tracks', value: 'repaired-tracks' },
  { label: 'Replaced leaking capacitor(s)', value: 'replaced-leaking-capacitors' },
  { label: 'Reset/Rebooted', value: 'reset-rebooted' },
  { label: 'Resoldered Dry Joints', value: 'resoldered-dry-joints' },
  { label: 'Serviced/overhauled mechanism', value: 'serviced-overhauled-mechanism' },
  { label: 'Upgraded', value: 'upgraded' },
  { label: 'Firmware updated', value: 'firmware-updated' }
];

export const TEST_OUTCOMES_RESULTS = [
  { label: 'Test PASSED', value: 'test-passed' },
  { label: 'Test FAILED', value: 'test-failed' }
];

export const CREATE_SERIALISED_POPUP_ACTIONS = [PartActionType.INSTALL, PartActionType.REPAIR, PartActionType.REPLACE, PartActionType.TEST, PartActionType.ADJUST, PartActionType.REMOVE];